import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Properties from './pages/Properties';
import PropertyForm from './components/forms/PropertyForm';
import Tenants from './pages/Tenants';
import TenantForm from './components/forms/TenantForm';
import TenantEmailTemplate from './components/forms/TenantEmailTemplate';
import Receipts from './pages/Receipts';
import TenantYearlySummary from './pages/TenantYearlySummary';
import ImportReceiptForm from './pages/ImportReceiptForm';
import ReceiptForm from './components/forms/ReceiptForm';
import SignReceipt from './pages/SignReceipt';
import Signatures from './pages/Signatures';
import Contracts from './pages/Contracts';
import ContractForm from './components/forms/ContractForm';
import ContractDetail from './pages/ContractDetail';
import SignContract from './pages/SignContract';
import EtatsDesLieux from './pages/EtatsDesLieux';
import EtatDesLieuxForm from './components/forms/EtatDesLieuxForm';
import EtatDesLieuxDetail from './pages/EtatDesLieuxDetail';
import SignEtatDesLieux from './pages/SignEtatDesLieux';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogForm from './pages/BlogForm';
import BlogAdmin from './pages/BlogAdmin';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        <Route path="/properties/neww" element={<PropertyForm />} />

        {/* Public blog routes */}
        <Route element={<Layout />}>
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
        </Route>

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Property routes */}
            <Route path="/properties" element={<Properties />} />
            <Route path="/properties/new" element={<PropertyForm />} />
            <Route path="/properties/edit/:id" element={<PropertyForm />} />

            {/* Tenant routes */}
            <Route path="/tenants" element={<Tenants />} />
            <Route path="/tenants/new" element={<TenantForm />} />
            <Route path="/tenants/edit/:id" element={<TenantForm />} />
            <Route path="/tenants/:id/email-template" element={<TenantEmailTemplate />} />
            <Route path="/properties/:propertyId/tenants" element={<Tenants />} />
            <Route path="/properties/:propertyId/tenants/new" element={<TenantForm />} />

            {/* Receipt routes */}
            <Route path="/receipts" element={<Receipts />} />
            <Route path="/receipts/new" element={<ReceiptForm />} />
            <Route path="/receipts/import" element={<ImportReceiptForm />} />
            <Route path="/receipts/:id/sign" element={<SignReceipt />} />
            <Route path="/signatures" element={<Signatures />} />
            <Route path="/tenants/:tenantId/receipts" element={<Receipts />} />
            <Route path="/tenants/:tenantId/receipts/new" element={<ReceiptForm />} />
            <Route path="/tenants/:tenantId/receipts/import" element={<ImportReceiptForm />} />
            <Route path="/tenants/:tenantId/yearly-summary" element={<TenantYearlySummary />} />

            {/* Contract routes */}
            <Route path="/contracts" element={<Contracts />} />
            <Route path="/contracts/new" element={<ContractForm />} />
            <Route path="/contracts/:id" element={<ContractDetail />} />
            <Route path="/contracts/:id/sign" element={<SignContract />} />
            <Route path="/contracts/edit/:id" element={<ContractForm />} />

            {/* État des lieux routes */}
            <Route path="/etat-des-lieux" element={<EtatsDesLieux />} />
            <Route path="/etat-des-lieux/new" element={<EtatDesLieuxForm />} />
            <Route path="/etat-des-lieux/:id" element={<EtatDesLieuxDetail />} />
            <Route path="/etat-des-lieux/:id/edit" element={<EtatDesLieuxForm />} />
            <Route path="/etat-des-lieux/:id/sign" element={<SignEtatDesLieux />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminDashboard />} />

            {/* Blog admin routes */}
            <Route path="/blog/admin" element={<BlogAdmin />} />
            <Route path="/blog/new" element={<BlogForm />} />
            <Route path="/blog/edit/:id" element={<BlogForm />} />
          </Route>
        </Route>
        
        {/* 404 route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;